export default __webpack_public_path__ + "static/webRotator/svg/7e6f1a453a16139af1d00ffd77d21270.svg";